<div class="tree-body">
  <div class="row m-0">
    <div class="col-sm-6">
      <bdg-input-field [control]="inputControl" [label]="label" [placeholder]="placeholder"></bdg-input-field>
    </div>
    <div class="col-sm-6 ml-auto mt-3">
      <bdg-button label="LIMPAR BUSCA" (click)="inputControl.setValue('')"></bdg-button>
    </div>
  </div>

  <div [ngStyle]="{ 'height.em': minHeight }" style="overflow-y: auto" class="mr-1 ml-0">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree-search">
      <!-- childnode -->
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        [ngStyle]="{ display: node?.visible ? 'flex' : 'none' }"
      >
        <mat-checkbox [(ngModel)]="node.selected" [disabled]="isViewOnly()" (ngModelChange)="updateAllSelected()">
          {{ provider.description(node) }}
        </mat-checkbox>
      </mat-tree-node>

      <!-- parentnode -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: canShowChildren">
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + provider.description(node)">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <mat-checkbox
            class="tree-margin"
            [checked]="allSelected(node)"
            [indeterminate]="someSelected(node)"
            [disabled]="isDisabled(node)"
            (change)="setAll(node, $event.checked)"
          >
            {{ provider.description(node) }}
          </mat-checkbox>
        </div>
        <div [class.tree-search-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>

<div class="tree-footer">
  <div *ngIf="canShowControls()">
    <div *ngIf="!isViewOnly(); else elseViewOnly" class="row m-0 d-flex flex-row-reverse">
      <div class="p-1">
        <bdg-button
          [label]="incluirLabel"
          (click)="onInclude()"
          [disabled]="!nullable && getSelected()?.length === 0"
          matStyle="raised"
        ></bdg-button>
      </div>
      <div class="p-1">
        <bdg-button label="CANCELAR" (click)="onCancel()"></bdg-button>
      </div>
    </div>

    <ng-template #elseViewOnly>
      <div class="row d-flex flex-row-reverse">
        <div class="p-1">
          <bdg-button label="FECHAR" (click)="onCancel()"></bdg-button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
